import React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, IconButton, Toolbar } from '@mui/material';
import useFullScreenDialogStyles from '../../styles/full-screen-dialog/full-screen-dialog.style';
import clsx from 'clsx';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Sticky from '../sticky/sticky';

interface Props {
    children: React.ReactNode;
    open: boolean;
    onClose: any;
    onBack?: () => void;
    size: 'small' | 'medium' | 'big' | 'large';
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

export default function FullScreenDialog(props: Props) {
    const { children, open, onClose, onBack } = props;
    const classes = useFullScreenDialogStyles();

    const getDialogSize = (): string => {
        return props.size === 'small'
            ? classes.small
            : props.size === 'medium'
            ? classes.medium
            : props.size === 'big'
            ? classes.big
            : classes.large;
    };

    const getBackButton = () => {
        if (onBack) {
            return (
                <IconButton
                    size="small"
                    edge="end"
                    color="inherit"
                    onClick={onBack}
                    aria-label="close"
                >
                    <ArrowBackIcon />
                </IconButton>
            );
        }
    };
    return (
        <Dialog
            className={clsx(classes.dialog, getDialogSize())}
            fullScreen
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
        >
            <Sticky order={1}>
                <AppBar className={classes.dialogHeader} elevation={0}>
                    <Toolbar className={classes.dialogToolbar}>
                        {getBackButton()}
                        <IconButton
                            size="small"
                            edge="end"
                            color="inherit"
                            onClick={onClose}
                            aria-label="close"
                            className={classes.closeButton}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </Sticky>
            {children}
        </Dialog>
    );
}
